module.exports = __webpack_public_path__ + "img/7.97b749f3.jpg";